// Loan / EMI Calculator Tool — monthly payment and total interest.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const loanCalculatorTool: Tool = {
  id: "loan-calculator",
  name: () => m.ln_tool_name(),
  description: () => m.ln_tool_description(),
  icon: "🏦",
  basePath: "/loan-calculator",
  status: "stable",
  tags: ["loan", "emi", "mortgage", "finance"],
  pages: [
    {
      name: () => m.ln_nav_main(),
      path: "/loan-calculator",
      description: () => m.ln_nav_main_desc(),
      icon: "🏦",
    },
  ],
};
